<template>
   <div class="empty-cart">
        <svg fill="none">
            <use  xlink:href="#EmptyCart" />
        </svg>
        <div class="empty-content">
            <h5>{{_T("Oops, You have no item")}}</h5>
            <!--<p>{{_T("We have tried to find it but it wasn’t there. Please add some product to be a good people")}}</p>-->
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
computed: {
        ...mapGetters([ "_T"]),
    }
}
</script>

<style lang="scss" scoped>
  .empty-cart {
    text-align: center;
    margin-top: $px50;
    height: calc(100% - #{$px350});
    .empty-content {
      margin-top: $px35;
      h5 {
        font-weight: bold;
        line-height: $px19;
        color: $font-color;
        margin-bottom: $px8;
      }
      p {
        padding: 0 $px20;
        font-weight: normal;
        font-size: $px12;
        line-height: $px14;
        text-align: center;
        color: $font-color;
      }
    }
    svg{
        height: $px195;
        width: $px227;
    }
  }
</style>